import { ICReportWidget } from '@/pages/funds/ic-report/components/ICReportWidget'
import { DownloadRawDataButtons } from '@/pages/funds/ic-report/components/composites/scenario-analysis-buttons'
import { BetaScenarioChart as BetaScenarioChartNew } from '@/pages/funds/ic-report/components/primitives/charts/BetaScenarioChartNew'
import { BaseICReportPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { beta } from '@/react-query/queries/ic-report/hooks'

export type BetaScenarioProps = BaseICReportPrimitive & {}

export const BetaScenario: React.FC<BetaScenarioProps> = () => {
  return (
    <div className="flex items-stretch gap-4">
      {/* <ICReportWidget
        widget={{
          component: BetaScenarioChart,
          query: beta.useHistoricalEvents,
          key: 'beta.historical_events',
          labels: labels.beta.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      /> */}
      <ICReportWidget
        widgetButtons={[
          <DownloadRawDataButtons filePrefix={`beta`} query={beta.useHistoricalEventsNew} />,
        ]}
        widget={{
          component: BetaScenarioChartNew,
          query: beta.useHistoricalEventsNew,
          key: 'beta.historical_events',
          labels: labels.beta.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      />
    </div>
  )
}
